import React from "react";
import { AiFillStar, AiOutlineHeart, AiOutlineStar } from "react-icons/ai";
import { Link } from "react-router-dom";
import { ImageUrl } from "../requestMethods";

const Product = ({ item }) => {
  return (
    <>
      <div className="single-product-card">
        <div className="product-img">
          <Link to={`/product/${item._id}`}>
            <img
              src={`${ImageUrl}` + item?.mainImg[0]?.filename}
              alt={item.title}
              width="300"
              className="product-img default img-fluid"
            />
          </Link>

          {item?.new && <p className="product-badge angle pink">new</p>}

          <div className="product-actions">
            <button className="btn-action">
              <AiOutlineHeart className="wishlist-icon" />
            </button>
          </div>
        </div>
        <div className="product-content">
          {/* <Link to={`/products/${item.categories}`} className="product-category">
            {item.categories}
          </Link> */}

          <Link to={`/product/${item._id}`}>
            <h3 className="product-title">{item.title}</h3>
          </Link>

          <div className="product-rating">
            <div className="rating-sec">
              <AiFillStar className="product-stars" />
             <p> {item.rating.toFixed(1)}</p>
            </div>
            <div className="review-sec">
              <p>| {item?.numReviews?.length} Reviews</p>
            </div>
          </div>

          <div className="product-color">
            {item.color.map((c, index) => {
              return (
                <span
                  className="color-box"
                  key={index}
                  style={{ backgroundColor: c }}
                ></span>
              );
            })}
          </div>

          {/* <div className="product-color">
            {item.size.map((c, index) => {
              return (
                <span
                  key={index}
                  style={{ backgroundColor: c, color: "black" }}
                >{" "}{c}{" "}{" "}</span>
              );
            })}
          </div> */}

          <div className="price-box">
            <p className="price">₹ {item.price}</p>
            <del>₹ {item.oldPrice}</del>
          </div>
          <div className="product-btn"></div>
        </div>
      </div>
    </>
  );
};

export default Product;
